import classNames from "classnames";
import { HiHeart, HiOutlineHeart } from "react-icons/hi";

export function FavoriteButton({
  selected,
  theme = "dark",
  className,
  onClick,
}: {
  selected: boolean;
  theme?: "dark" | "light";
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}) {
  return (
    <div className={className}>
      <div
        className={classNames(
          "cn-wp-button-favorite-md tw:cursor-pointer tw:h-full",
          theme === "dark"
            ? "tw:text-white hover:tw:text-gray-800"
            : "tw:text-gray-800",
        )}
        onClick={onClick}
      >
        <div className="tw:flex tw:flex-row tw:items-center tw:gap-3 tw:p-1">
          {!selected ? (
            <HiOutlineHeart className={classNames("tw:h-4 tw:w-4")} />
          ) : (
            <HiHeart className={classNames("tw:h-4 tw:w-4 tw:text-red-500")} />
          )}

          {!selected ? (
            <div className="tw:text-lg">Favorite</div>
          ) : (
            <div className="tw:text-lg">Favorited</div>
          )}
        </div>
      </div>
    </div>
  );
}
